// src/pages/LoginPage.jsx
import config from '../config/config'; // Import der Konfigurationsdatei
import { Header } from '../components/Header';
import { useAuth } from '../contexts/AuthContext'; // Import the useAuth hook
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Input, Checkbox } from '@progress/kendo-react-inputs';
import styled from 'styled-components';
import { Button } from '@progress/kendo-react-buttons';
import { Card, CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';

import { Loader } from '@progress/kendo-react-indicators';
import { AppContext } from '../AppContext'; // Neu: Import für showNotification

const StyledButton = styled(Button)`
    font-weight: bold;
    font-size: 20px;
`;

const UNSPLASH_ACCESS_KEY = 'gmtpktF-Tehpfe6D-tj18sxzX-BABuramv0ws4Qcec4';
const UNSPLASH_API_URL = `https://api.unsplash.com/photos/random?query=wallpapers&client_id=${UNSPLASH_ACCESS_KEY}`;

// Wert "LoadLocalRandomPics" hart im Code gesetzt.
const LoadLocalRandomPics = true; // true => /random_image, false => Unsplash

const LoginPage = () => {
  const [credentials, setCredentials] = useState({ EBTBusername: '', EBTBpassword: '' });
  const [backgroundImage, setBackgroundImage] = useState('');
  const navigate = useNavigate();
  const { setUserId } = useAuth(); // Use the useAuth hook to get setUserId
  const { showNotification } = React.useContext(AppContext); // Neu: showNotification aus AppContext

  // Ladezustand für den Loader
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchBackgroundImage = async () => {
      try {
        if (LoadLocalRandomPics) {
          // Lokale Bilder
          setBackgroundImage(`${config.host}/random_image`);
        } else {
          // Unsplash
          const response = await axios.get(UNSPLASH_API_URL);
          setBackgroundImage(response.data.urls.full);
        }
      } catch (error) {
        console.error('Error fetching background image:', error);
      }
    };
    fetchBackgroundImage();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setCredentials((prevCredentials) => ({ ...prevCredentials, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true); // Ladezustand aktivieren

    try {
      if (!credentials.EBTBusername || !credentials.EBTBpassword) {
        showNotification('error', 'Bitte geben Sie Benutzernamen und Kennwort ein.');
        return;
      }

      const response = await axios.post(`${config.host}/login-backend`, {
        username: credentials.EBTBusername,
        password: credentials.EBTBpassword,
      });

      if (response.data.success) {
        const userId = response.data.userId;
        setUserId(userId); // Update userId in context
        showNotification('success', 'Login erfolgreich!'); // Optional: Erfolgsmeldung hinzugefügt, um der Edit-Logik zu ähneln
        navigate(response.data.redirect || '/construction-diary');
      } else {
        showNotification('error', response.data.message || 'Login fehlgeschlagen!');
      }
    } catch (error) {
      showNotification('error', error.response?.data?.message || 'Unknown username or wrong password!');
    } finally {
      // Ladezustand wieder deaktivieren
      setLoading(false);
    }
  };

  return (
    <div
      className="k-flex k-justify-center k-items-center k-h-screen"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
      }}
    >
      <Header />

      {/* Die Card bekommt teiltransparentes Weiß + Blur-Effekt im Hintergrund */}
      <Card
        className="k-shadow-lg"
        style={{
          width: '400px',
          marginTop: '200px',
          marginLeft: 'auto',
          marginRight: 'auto',
          backgroundColor: 'rgba(255, 255, 255, 0.75)',
          backdropFilter: 'blur(6px)',
        }}
      >
        <CardHeader>
          <CardTitle><b>Anmeldung</b></CardTitle>
        </CardHeader>
        <CardBody>
          <form onSubmit={handleSubmit} className="k-mt-4">
            <div className="k-mb-3">
              <label className="k-form-label">Benutzername</label>
              <Input
                name="EBTBusername"
                value={credentials.EBTBusername}
                onChange={handleChange}
                required
              />
            </div>
            <div className="k-mb-3">
              <label className="k-form-label">Passwort</label>
              <Input
                name="EBTBpassword"
                type="password"
                value={credentials.EBTBpassword}
                onChange={handleChange}
                required
              />
            </div>
            <div className="k-mb-3">
              <Checkbox 
                label="Angemeldet bleiben" 
                style={{ marginTop: '15px', marginBottom: '15px' }}
              />
            </div>
            <StyledButton
              themeColor="primary"
              style={{ width: '100%', marginTop: '10px' }}
              type="submit"
            >
              Login
            </StyledButton>
          </form>
        </CardBody>
      </Card>

      {/* Overlay + Loader, wird nur angezeigt, wenn loading === true */}
      {loading && (
        <div
          style={{
            position: 'fixed',
            zIndex: 9999,
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ textAlign: 'center' }}>
            <Loader size="large" type="infinite-spinner" />
            <p><b>Anmeldung läuft...</b></p>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginPage;